module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-56.86034133.svg";